import script from "./MyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MyHeader.vue?vue&type=script&setup=true&lang=js"

import "./MyHeader.vue?vue&type=style&index=0&id=4401144b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4401144b"]])

export default __exports__